import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除员工成本")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更换员工成本")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")

  
const __default__ = {
  name: 'leaseCost'
}
import eptBtn from '@/components/ExportButton.vue'
import {  onActivated, ref, reactive } from 'vue'
import tbMix, { orgCfig } from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  'POST/house_lease_costs/list': fetchList,
  // 根据年月和团队id查询分摊的员工
  'POST/house_lease_costs/user': houseUserApi,
  // 根据员工id和年月获取成本
  'POST/house_lease_costs/user_cost': userCostTypeApi,
  // 删除个人成本
  'POST/house_lease_costs/delete_cost': delHandleApi,
  // 更换员工成本
  'PATCH/house_lease_costs/update_org': updateOrgCost,
  // 导出员工租赁成本
  'POST/house_lease_costs/export': downloadApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_height,
  MI_total, MI_pageChange, MI_sizeChange, MI_identify,
  MI_params, MI_modifyForm
} = new tbMix(fetchList)
const route = useRoute()

const searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'key',
  },
  {
    type: 'SELECT',
    label: '费用类型',
    value: '',
    upKey: 'feeType',
    options: [
      {
        label: '房租',
        id: 'Rent'
      },
      {
        label: '水电费',
        id: 'Utilities'
      },
      {
        label: '物业管理费',
        id: 'PM'
      },
      {
        label: '其他',
        id: 'Other'
      },
    ],
    props: { clearable: true, placeholder: '请选择费用类型' },
    seleProps: {}
  }
])

const searchHandle = (params: any) => {
  fetchData({
    ...route.params,
    ...params,
  }, {}, 1)

}
// 删除员工成本
const employeeFormRef = ref()
const delFg = ref<boolean>(false)
let employeeList: any = ref([])
let employeeTypes: any = ref([])
const employeeDelObj = reactive({
  userId: '',
  category: [],
})

const employeeRules = reactive({
  userId: [{ required: true, message: '请选择员工', trigger: 'change' }],
  category: [{ required: true, message: '请选择类型', trigger: 'change' }],
})

houseUserApi(route.params).then(rep => {
  // 获取当月办公室员工
  employeeList.value = rep
})
const employeeCgHd = (val: string) => {
  userCostTypeApi({userId: val, date: route.params.date}).then(rep => {
    employeeTypes.value = rep
    
  })
}
// 员工成本删除
const delEmployeeHandle = () => {
  employeeFormRef.value.validate(async (valid: boolean) => {
    if (valid) {
      await delHandleApi({
        ...employeeDelObj,
        date: route.params.date
      })
      ElMessage.success('删除成功')
      delFg.value = false
      employeeFormRef.value.resetFields()
      searchHandle(MI_params)
    }
  })
}

// 更换员工成本
const changeFg = ref<boolean>(false)
const changeConfig = ref([
  {
    type: 'SELECT',
    label: '员工',
    value: '',
    upKey: 'userId',
    options: employeeList,
    props: { clearable: true, placeholder: '请选员工',},
    seleProps: { label: 'realName', valueName: 'userId', },
    rule: [{ required: true, message: '请输选择员工', trigger: 'change' }],
    selectCb: async (val: string, upkey: string) => {
      let _types = await userCostTypeApi({userId: val, date: route.params.date})
      changeConfig.value[2].options = _types.map((e: any) => {
        e.label = types[e.category]
        return e
      })
    }
  },
  orgCfig({
    rule: [{ required: true, message: '请输选择团队', trigger: 'change' }],
  }),
  /* {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: orgListApi,
    props: { },
    rule: [
      { required: true, message: '请输选择团队', trigger: 'change' },
    ],
    seleProps: {
      label: 'name',
      valueName: 'id',
    }
  }, */
  {
    type: 'SELECT',
    label: '类型',
    value: [],
    upKey: 'category',
    options: [],
    props: { multiple: true, placeholder: '请选择类型', 'collapse-tags': true },
    rule: [
      { required: true, message: '请输选择类型', trigger: 'change' },
    ],
    seleProps: {
      label: 'label',
      valueName: 'category',
    }
  },
])

const costUpdataHandle = () => {
  MI_modifyForm({}, changeConfig, changeFg, async (params: object) => {
    await updateOrgCost({...params, date: route.params.date})
    ElMessage.success('修改成功')
    changeFg.value = false
    searchHandle(MI_params)
  })
}

// -----
const types: any = {
  Rent: '房租',
  Utilities: '水电费',
  PM: '物业管理费',
  Other: '其他',
}
const formatFeeType = (row: {userId: number}, column: any, cellValue: string, index: number) =>{
  switch (cellValue) {
    case 'Rent':
      return row.userId === 0 ? '未分配的房租' : '房租'
      break;
    case 'Utilities':
      return '水电费'
      break;
    case 'PM':
      return row.userId === 0 ? '未分配的物业管理费' : '物业管理费'
      break;
    case 'Other':
      return '其他'
      break;
  
    default:
      break;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "员工租赁成本" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      icon: "Back",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ name: 'leaseTeamCost', params: {orgId: _ctx.$route.params.orgId, orgName: _ctx.$route.params.orgName }})))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "danger",
      class: "mb-10 mt-10",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (delFg.value = true))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })), [
      [_directive_permission, 'Delete']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      class: "mb-10 mt-10",
      onClick: costUpdataHandle
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _createVNode(eptBtn, {
      exportFn: _unref(downloadApi),
      exportText: '导出员工租赁成本',
      fileName: '员工租赁成本',
      exportParam: {orgId: _ctx.$route.params.orgId, date: _ctx.$route.params.date}
    }, null, 8, ["exportFn", "exportParam"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "日期",
          prop: "date"
        }),
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName"
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName"
        }),
        _createVNode(_component_el_table_column, {
          label: "办公所在地",
          prop: "area"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "feeType",
          formatter: formatFeeType
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      class: "mt-10",
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "员工成本删除",
      onClose: _cache[8] || (_cache[8] = ($event: any) => {employeeFormRef.value.resetFields();_isRef(employeeTypes) //@ts-ignore
 ? employeeTypes.value = [] : employeeTypes = []}),
      modelValue: delFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((delFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (delFg.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (delEmployeeHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "employeeFormRef",
          ref: employeeFormRef,
          inline: true,
          model: _unref(employeeDelObj),
          "label-width": "120px",
          rules: _unref(employeeRules)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "员工",
              prop: "userId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(employeeDelObj).userId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(employeeDelObj).userId) = $event)),
                  placeholder: "请选择员工",
                  clearable: "",
                  onChange: employeeCgHd
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(employeeList), (_employee) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: _employee.realName,
                        value: _employee.userId,
                        key: _employee.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  multiple: "",
                  "collapse-tags": "",
                  modelValue: _unref(employeeDelObj).category,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(employeeDelObj).category) = $event)),
                  placeholder: "请选择类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(employeeTypes), (_type) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: types[_type.category],
                        value: _type.category,
                        key: _type.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "更换员工成本",
      modelValue: changeFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((changeFg).value = $event))
    }, {
      default: _withCtx(() => [
        (changeFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: changeConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})